import { render, staticRenderFns } from "./gioi-thieu.vue?vue&type=template&id=74e0b6b4&"
import script from "./gioi-thieu.vue?vue&type=script&lang=js&"
export * from "./gioi-thieu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports